import { useState, useCallback } from 'react'

import { withdrawSoundKey } from '@/core/keys'

export function getWithdrawSoundEnabled(): boolean {
	const stored = localStorage.getItem(withdrawSoundKey)
	// Default to true (sound enabled) if not set
	return stored === null ? true : stored === 'true'
}

export function useWithdrawSoundPreference() {
	const [soundEnabled, setSoundEnabled] = useState(getWithdrawSoundEnabled)

	const toggleSound = useCallback(() => {
		setSoundEnabled((prev) => {
			const newValue = !prev
			localStorage.setItem(withdrawSoundKey, String(newValue))
			return newValue
		})
	}, [])

	return { soundEnabled, toggleSound }
}
